/* eslint-disable no-magic-numbers */
import { isNumber, round } from 'lodash';
import { TPlaceOrderSide } from '@trader/types';

export const defaultPipSize = 0.00001;

export const getPipSizeNumber = (pipSize: number | string) => {
  const str = String(pipSize).replace(',', '.');
  const decimalPart = str.split('.')[1];

  if (decimalPart) {
    return decimalPart.length;
  }
  return +pipSize;
};

export const formatByPipSize = (
  value: number | string,
  pipSize: number | string = defaultPipSize
): string => {
  const maxDecimals = getPipSizeNumber(pipSize);
  return `${round(+value, maxDecimals).toFixed(maxDecimals)}`;
};

export const getValueInRange = (
  value: string | number | undefined | null,
  { min, max }: { min?: number; max?: number }
) => {
  const numericValue = +(value ?? 0);
  if (isNumber(min) && min > numericValue) {
    return min;
  }
  if (isNumber(max) && max < numericValue) {
    return max;
  }

  return numericValue;
};

export const getAmountDigitsAfterDot = (value: number): number => {
  if (!value) {
    return 0;
  }
  if (value.toString().includes('.')) {
    const maxDigit = value.toString().split('.');
    const valueMax = maxDigit[maxDigit.length - 1];
    return valueMax.length;
  }
  return 0;
};

const getDigitsAfterComma = (value: string | number) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, decimalPart] = String(value).replace(',', '.').split('.');
  if (decimalPart) {
    return getPipSizeNumber(decimalPart);
  }
  return 1;
};

export const isValueTimesStep = (
  value: string | number,
  step: string | number
) => {
  const valueMantissa = getDigitsAfterComma(value);
  const stepMantissa = getDigitsAfterComma(step);

  const normalizePow =
    valueMantissa > stepMantissa ? valueMantissa : stepMantissa;
  const normalizeMultiplier = 10 ** normalizePow;

  const integerValue = +value * normalizeMultiplier;
  const integerStep = +step * normalizeMultiplier;

  return integerValue % integerStep === 0;
};

export const getPriceDifference = (stopsLevel: number, pipSize: number) =>
  stopsLevel * pipSize;

export const getLimitPrice = (
  stopsLevel: number,
  pipSize: number,
  bid: number,
  ask: number,
  side: TPlaceOrderSide
) => {
  const difference = getPriceDifference(stopsLevel, pipSize);
  if (side === 'Buy') {
    return formatByPipSize(bid + difference, pipSize);
  }
  return formatByPipSize(ask - difference, pipSize);
};
